<app-header-panel></app-header-panel>
<!-- breadcrumb -->
<app-breadcrumbs></app-breadcrumbs>
<!-- Home page menu display options -->
<router-outlet></router-outlet>
